import React from 'react';
import EmsNavbar from "../../frontend/EmsNavbar";
import { Box } from '@mui/material';
const WorkShopHome = () => {
    return (

        <><EmsNavbar />
            <Box sx={{ color: '#000000', }} style={{ marginLeft: '39%', marginTop: '2%' }}>
                <h1 style={{ marginTop: '17%' }}>WorkShop Home Page</h1>
                <h4> WorkShop Management System</h4>

            </Box>
        </>

    )

}


export default WorkShopHome;
